const styles = (theme) => ({
    root: {
        fontSize: 18,
        textAlign: 'center',
    },
});

export default styles;
